// TicketDeCaisseModal.tsx
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  order,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  findPaymentsByTicketApi,
  listOperationsByPaymentMethod,
} from "../../../_App/Redux/Slices/payments/PaymentSlice";

import { parametrageCaisse } from "../../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import Barcode from "react-barcode";
import {
  SelectedOrganisation,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import { findTicketsByOrderApi } from "../../../_App/Redux/Slices/tickets/TicketSlice";
import { useTranslation } from "react-i18next";

const TicketCaissePaidModalMinime =  ({
  ShowModal,
  setShowModal,
  order_id,
  ticket,
}: any) => {
  const { t } = useTranslation();

  const formatDate = ({ date }: { date: string }) => {
    const options: Intl.DateTimeFormatOptions = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };
    return new Date(date).toLocaleDateString(undefined, options);
  };
  const mainOrder = useAppSelector(order);
  const [retrievedTicket, setretrievedTicket] = useState<any>();
  const formatTime = ({ date }: { date: string }) => {
    const options: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return new Date(date).toLocaleTimeString(undefined, options);
  };
  const orderItemsGroupedByTva = _.groupBy(
    retrievedTicket?.ticket_order?.items,
    "article.tva"
  );
  const currentDate = new Date();
  const paymentDetails = useAppSelector(listOperationsByPaymentMethod);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const fetch = async () => {
      if (ticket) {
        setretrievedTicket(ticket);
      } else if(order_id){
        const res = await dispatch(findTicketsByOrderApi(order_id));
        if (res.payload && res.payload[0]) {
          dispatch(findPaymentsByTicketApi(res.payload[0]._id));
          setretrievedTicket(res.payload[0]);
        }
      }
    };
    fetch();
  }, [ticket, order_id]);

  const componentRef = useRef<HTMLDivElement>(null);
  const magasin = useAppSelector(SelectedOrganisation);
  const parametrage = useAppSelector(parametrageCaisse);
  const handlePrint = () => {
    // Access the hidden iframe and trigger its print method
    const printFrame = document.getElementById(
      "print-frame"
    ) as HTMLIFrameElement | null;
    if (printFrame) {
      printFrame.contentWindow?.print();
    }
  };

  return (
    <Modal
      show={ShowModal}
      onHide={() => setShowModal(false)}
      className="ticket-modal"
      style={{ display: "flex", justifyContent: "center" }}
      size="lg"
    >
      <div ref={componentRef}>
        <div className="container-ticket" id="print-content ">
          <div className="receipt_header">
            <h1>
              <span>{retrievedTicket?.ticket_order?.societe_id?.nom}</span>
            </h1>
            <h2 className="m-0">
              {retrievedTicket?.ticket_order?.organisation_id?.description || ""}{" "}
              <span>
                {"Tel: " + (retrievedTicket?.ticket_order?.societe_id?.tel || "")}
              </span>
            </h2>
          </div>

          <div className="row">
            <div className="col-12" style={{ fontSize: "12px" }}>
              <p className="inv-street-addr mb-0">
                <b>{t('Caissier')}</b>{" "}
                {(retrievedTicket?.ticket_order?.user_id?.nom || "") +
                  " " +
                  (retrievedTicket?.ticket_order?.user_id?.prenom || "")}
              </p>
            </div>
            {/* <div className="col-6" style={{ fontSize: "12px" }}>
              <p className="inv-street-addr mb-0">
                <b>Vendeur</b>{" "}
                {(ticket?.ticket_order?.vendeur?.nom || "") +
                  " " +
                  (ticket?.ticket_order?.vendeur?.prenom || "")}
              </p>
            </div> */}
          </div>

          <div className="receipt_body">
            <div className="row">
              <div className="col-6">
                {" "}
                <div className="barcode" style={{}}>
                  {retrievedTicket  && ticket.main_order && (
                    <Barcode
                      value={ticket?.ticket_order.order_number}
                      height={30}
                      width={1}
                      displayValue={false}
                    />
                  )}
                </div>
              </div>
              <div
                className="col-6"
                style={{
                  padding: "0px 12px",
                  textAlign: "right",
                  marginTop: "5px",
                }}
              >
                {" "}
                <div className="date_time_con">
                  <div className="date">
                    {" "}
                    {formatDate({
                      date: currentDate.toISOString(),
                    })}{" "}
                    {formatTime({ date: new Date().toISOString() })}
                  </div>
                  {/* <div className="time">
                    {" "}
                    {formatTime({ date: new Date().toISOString() })}
                  </div> */}
                </div>
              </div>
            </div>

            <div
              className="ticket-items"
              style={{
                borderTop: "1px dashed #000",
                margin: 0,
              }}
            >
              <table
                style={{
                  whiteSpace: "normal",
                  borderBottom: "1px dashed #000",
                }}
              >
                {/* <thead>
                  <tr>
                    <th>Désignation</th>
                    <th>Total</th>
                  </tr>
                </thead> */}
                <tbody>
                  {retrievedTicket
                    ? retrievedTicket?.ticket_order.items.map((item: any) => {
                        return parseInt(item.quantity) !== 0 ? (
                          <>
                            <tr key={item.article._id}>
                              <td className="p-0">
                                <b></b> {item.quantity + "x "}
                                {item.article.titre.fr}
                                {item.article.caracteristiques &&
                                item.article.caracteristiques.length
                                  ? item.article.caracteristiques.map(
                                      (caracteristique: any) =>
                                        caracteristique.value.libelle
                                          ? caracteristique.value.libelle
                                          : caracteristique.value
                                    )
                                  : null}
                              </td>

                              <td className="p-0">
                                {Number(item.prix_total)?.toFixed(3)}
                              </td>
                            </tr>
                            <tr>
                              <td>{('Timbre')}</td>
                              <td>
                                {ticket?.ticket_order?.societe_id?.timbre?.toFixed(
                                  3
                                )}{" "}
                              </td>
                            </tr>
                            {item.remise ? (
                              <tr>
                                <td
                                  className="p-0"
                                  style={{ textAlign: "right" }}
                                >
                                  {-item.remise}{" "}
                                  {item.typeRemise === "pourcentage" ? "%" : ""}{" "}
                                </td>
                                <td
                                  className="p-0"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {item.prixNet}
                                </td>
                              </tr>
                            ) : null}
                          </>
                        ) : null;
                      })
                    : null}
                </tbody>

                <tfoot>
                  {/* <tr></tr>
                  {reduction() > 0 ? (
                    <tr>
                      <td>Reduction</td>

                      <td> {-reduction()} </td>
                    </tr>
                  ) : null} */}

                  {/* <tr>
                    <td colSpan={2}>
                      {ticket?.ticket_order.items.map((item, index) =>
                        item.remiseClient > 0 ? (
                          <div
                            className="row"
                            key={index}
                            style={{
                              borderBottom: "1px dashed #000",
                            }}
                          >
                            <div className="col-8" style={{ fontSize: "12px" }}>
                              <p style={{ textAlign: "left" }}>Remise client</p>
                            </div>
                            <div className="col-4" style={{ fontSize: "12px" }}>
                              <p>{item.remiseClient + "%"}</p>
                            </div>
                          </div>
                        ) : null
                      )}
                    </td>
                  </tr> */}

                  <tr style={{ fontWeight: "bold", fontSize: "20px" }}>
                    <td className="p-0">{t('Total Net')}</td>

                    <td className="p-0">
                      {Number(retrievedTicket?.ticket_order.totalNet)?.toFixed(3)}{" "}
                    </td>
                  </tr>
                  {Object.entries(paymentDetails).length ? (
                    <>
                      {Object.entries(paymentDetails).map(([key, value]) => (
                        <tr key={key}>
                          <td
                            className="p-0"
                            onClick={() => console.log(paymentDetails)}
                          >
                            {" "}
                            {key}{" "}
                          </td>

                          <td className="p-0">
                            {value
                              .reduce((sum, item) => sum + item.amount, 0)
                              .toFixed(3)}
                          </td>
                        </tr>
                      ))}

                      {Object.entries(paymentDetails).map(
                        ([key, value]) =>
                          key === "Espéces" &&
                          (value[0].rendu ? (
                            <tr key={key}>
                              <td className="p-0"> {t('Rendu')} </td>
                              <td className="p-0">
                                {" "}
                                {value[0].rendu.toFixed(3)}{" "}
                              </td>
                            </tr>
                          ) : null)
                      )}
                    </>
                  ) : null}
                </tfoot>
              </table>
              {/* {Object.entries(orderItemsGroupedByTva).map(
                ([key, items]: any) => (
                  <div
                    className="row"
                    key={key}
                    style={{
                      borderBottom: "1px dashed #000",
                      margin: "2px",
                    }}
                  >
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Taxe</p>
                      <p className="inv-email-address">TVA</p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Base HT</p>
                      <p className="inv-email-address">
                        {items
                          .reduce(
                            (acc: any, val: any) =>
                              acc +
                              val.article.prix_vente_ht * val.quantity -
                              val.article.prix_vente_ht *
                                val.quantity *
                                (val.remise / 100) -
                              val.article.prix_vente_ht *
                                val.quantity *
                                (val.remiseClient / 100),
                            0
                          )
                          .toFixed(3)}
                      </p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Taux</p>
                      <p className="inv-email-address">
                        {key === "undefined" ? 0 : key}
                      </p>
                    </div>
                    <div className="col-3" style={{ fontSize: "12px" }}>
                      <p className="inv-street-addr mb-0">Montant</p>
                      <p className="inv-email-address">
                        {(
                          (items.reduce(
                            (acc: any, val: any) =>
                              acc + val.article.prix_vente_ht,
                            0
                          ) *
                            Number(key)) /
                          100
                        ).toFixed(3)}
                      </p>
                    </div>
                  </div>
                )
              )} */}
            </div>
          </div>
          <div className="receipt-footer mt-2 ">
            <p style={{ textAlign: "center" }}>
              {parametrage &&
                parametrage.message_promo !== null &&
                parametrage.message_promo.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
            </p>
          </div>
        </div>
      </div>
      <ReactToPrint
        trigger={() => (
          <Button
            variant="contained"
            color="primary"
            onClick={handlePrint}
            className="btn-info"
          >
            Print
          </Button>
        )}
        content={() => componentRef.current}
      />
      {/* Hidden iframe for printing */}
      <iframe
        id="print-frame"
        title="print-frame"
        style={{ display: "none" }}
        onLoad={() => handlePrint()}
      />
    </Modal>
  );
};

export default TicketCaissePaidModalMinime;
